"use strict";
const BAD_REQUEST_STATUS_CODE = 400;
const schemaValidationErrorResponse = (res, message, error) => res.status(BAD_REQUEST_STATUS_CODE).send(message ? `${message} ${error}` : error);
const buildSchemaValidationMiddleware = (validateRequest, message) => (req, res, next) => {
    const { error } = validateRequest(req);
    return error ? schemaValidationErrorResponse(res, message, error.message) : next();
};
/**
 * Helper to validate any object structure with Joi schema
 * @param {Object} body - Object for validation
 * @param {import('joi').Schema} schema - Joi Schema for validation
 * @param {Object} [errorMessages={}] - Map of custom error messages
 * @returns {import('joi').ValidationResult}
 *
 * @example
 * const isUserValid = validateBody(userObj, Joi.object({
 *     service_id: Joi.string().required(),
 *     email: Joi.string().email().required(),
 * }));
 */
const validateBody = (body, schema, errorMessages = {}) => {
    const options = {
        abortEarly: false,
        language: {
            key: '{{key}} ', // removing of double quotes in error messages
        },
        allowUnknown: true,
    };
    const { error } = schema.validate(body, options);
    let errors;
    if (error) {
        errors = {};
        const isCustomMessages = errorMessages && Object.keys(errorMessages).length;
        error.details.forEach((err) => {
            if (isCustomMessages && errorMessages[err.path]) {
                errors[err.path] = `${body[err.path]} ${errorMessages[err.path]}`;
            }
            else {
                errors[err.path] = [err.message];
            }
        });
    }
    return errors;
};
/**
 *
 * @param {import('express').Request} req
 * @param {import('express').Response} res
 * @param {import('express').NextFunction} next
 * @param {import('joi').Schema} schema
 * @returns {*}
 *
 * @example
 * const endpointV1Validation = (req, res, next) => commonValidateBodyMiddleware(req, res, next, Joi.object({
 *     service_id: JOI.string().required(),
 * }));
 *
 * app.post('/api/v1/endpoint', endpointV1Validation, (req, res) => { res.sendStatus(200).json({ valid: true }) });
 */
const commonValidateBodyMiddleware = (req, res, next, schema) => {
    try {
        const errors = validateBody(req.body, schema);
        if (errors) {
            res.status(400).send({ message: JSON.stringify(errors) });
        }
        else {
            next();
        }
    }
    catch (err) {
        res.status(500).send({ error: err });
    }
};
module.exports = {
    buildSchemaValidationMiddleware,
    validateBody,
    commonValidateBodyMiddleware,
};
//# sourceMappingURL=joiValidationService.js.map